import { onBeforeUnmount, watch, type Ref } from 'vue'
import { isTopmostModal, registerModal, unregisterModal } from './base-modal-stack'

/** Give standalone overlays the same Escape ordering as BaseModal. */
export function useStandaloneModalEscape(
  overlay: Ref<HTMLElement | null>,
  close: () => void,
  canClose: () => boolean = () => true,
): void {
  const id = Symbol('standalone-modal')
  let previousFocus: HTMLElement | null = null
  function onKeydown(event: KeyboardEvent): void {
    if (event.key !== 'Escape' || !isTopmostModal(id) || event.defaultPrevented) return
    event.preventDefault()
    event.stopImmediatePropagation()
    if (canClose()) close()
  }
  function cleanup(): void {
    document.removeEventListener('keydown', onKeydown)
    unregisterModal(id)
    if (previousFocus?.isConnected) previousFocus.focus()
    previousFocus = null
  }
  watch(overlay, (element) => {
    cleanup()
    if (!element) return
    previousFocus = document.activeElement instanceof HTMLElement ? document.activeElement : null
    registerModal(id, element)
    element.focus()
    document.addEventListener('keydown', onKeydown)
  }, { flush: 'post' })
  onBeforeUnmount(cleanup)
}
